import { render, staticRenderFns } from "./VTextGroup.vue?vue&type=template&id=317b4722&"
import script from "./VTextGroup.vue?vue&type=script&lang=js&"
export * from "./VTextGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports